<template>
	<VAceEditor
		v-model:value="editorContents"
		:id="id"
		lang="json"
		style="height: 300px;"
		v-bind="$attrs"
	/>
</template>

<script>
import { VAceEditor } from 'vue3-ace-editor'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-chrome'

export default {
	name: 'BaseJsonAceEditor',
	inheritAttrs: false,
	components: {
		VAceEditor,
	},
	props: {
		id: {
			type: String,
			required: true,
		},
		modelValue: {
			type: [String, Number],
			required: true,
		},
	},
	data() {
		return {
			editorContents: this.modelValue,
		};
	},
	watch: {
		modelValue(newValue) {
			this.editorContents = newValue;
		},
		editorContents(newValue) {
			this.$emit('update:modelValue', newValue);
		},
	},
};
</script>
